import { ServiceBase } from './core/service-base';
export class AuthServices extends ServiceBase {
  // Implement method call API
  login = async (params: { message: string; signature: string }) => {
    return this.post('/auth/login-wallet-address', params);
  };
}
